export const getSubscriptions = state => state.subscriptions
export const getAllSelectedTopicIds = state => getSubscriptions(state).getIn(['topics', 'selectedTopicIds'])
export const getSelectedEditionIds = state => getSubscriptions(state).getIn(['editions', 'selectedEditionIds'])
